
class BusinessVenueSelectCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;
    private infoLabel:MUILabel = null;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.infoLabel = MUIOutlet(this, "info-lbl", "MUILabel");
        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set item(venue:any){
        this.nameLabel.text = venue["name"];

        let taken = venue["linkedLicenseID"] != null && venue["linkedLicenseID"].length > 0;
        let parts = [ venue["environment"] ];
        if (venue["status"] != 1) parts.push( MIOLocalizeString("DISABLED", "DISABLED") );
        if (taken) parts.push( MIOLocalizeString("ALREADY_LINKED", "ALREADY LINKED") );
        this.infoLabel.text = parts.join(" · ");

        // Same signal as the licences list: grey for a venue that is not available.
        if (taken) MUICoreLayerAddStyle(this.nameLabel.layer, "grey");
        else MUICoreLayerRemoveStyle(this.nameLabel.layer, "grey");
    }
}

// Popover listing the venues auth knows about, for linking a licence to the one it
// belongs to. Fed by the HQ API (not a fetch request: venues are not entities of this
// schema), filtered locally by the search field. Venues already claimed by another
// licence are shown greyed and cannot be picked, so the uniqueness rule is visible
// before the server enforces it.
class BusinessVenueSelectViewController extends MUIViewController
{
    static newInstance() : BusinessVenueSelectViewController {
        let vc = new BusinessVenueSelectViewController("business-venue-select-view");
        vc.initWithResource("layout/licenses/BusinessVenueSelectView.html");
        return vc;
    }

    get preferredContentSize(): MIOSize {
        return new MIOSize(360, 480);
    }

    completionTarget:any = null;
    completionBlock:any = null;

    private searchTextField:MUITextField = null;
    private tableView:UITableView = null;
    private venues:any[] = [];
    private filtered:any[] = [];
    private searchString:string = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.searchTextField = MUIOutlet(this, "search-bar", "MUITextField");
        this.searchTextField.setOnChangeText(this, function(this:BusinessVenueSelectViewController, control:MUITextField, value:string){
            this.searchString = value != null && value.trim().length > 0 ? value.trim().toLowerCase() : null;
            this.applyFilter();
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.fetchBusinessLicenseVenues( (data:any, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error);
                return;
            }
            this.venues = data ?? [];
            this.applyFilter();
        });
    }

    private applyFilter(){
        let s = this.searchString;
        this.filtered = s == null ? this.venues : this.venues.filter( (v:any) => (v["name"] as string ?? "").toLowerCase().indexOf(s) >= 0 || (v["id"] as string).toLowerCase().indexOf(s) >= 0 );
        if (this.viewIsLoaded) this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){
        return 1;
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        return this.filtered.length;
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier("VenueCell") as BusinessVenueSelectCell;
        cell.item = this.filtered[indexPath.row];
        return cell;
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let venue = this.filtered[indexPath.row];
        let taken = venue["linkedLicenseID"] != null && venue["linkedLicenseID"].length > 0;
        if (taken) return;

        if (this.completionBlock != null && this.completionTarget != null) this.completionBlock.call(this.completionTarget, venue);
        this.dismissViewController(true);
    }
}
